.features-card-type-6 {
  border: var(--border-size-sm) solid var(--border-color-secondary);
  align-self: stretch;

  @include below($breakpoint-desktop) {
    height: 100%;
  }
}

.features-card-type-6__icon {
  margin-bottom: var(--spacing-xl);

  .me-icon {
    min-width: 48px;
  }
}
